import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";

const QuestionAsked = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => {
        navigate(`cards/${notification?.data?.id ?? ""}?tab=queries`);
      }}
      sx={wrapperStyles(darkMode)}
    >
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <Info sx={{ color: "#6366f1", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {notification?.title ?? "Notification"}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#d1d5db" : "#4b5563",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default QuestionAsked;
